import { ActionsUnion, createAction } from '../helpers';
import { IPersonalityReport } from './types';

export enum EPersonalityReportActions {
  GET = 'PERSONALITY_REPORT_GET',
  GET_SUCCESS = 'PERSONALITY_REPORT_GET_SUCCESS',
  GET_VISION = 'PERSONALITY_REPORT_VISION_GET',
  GET_VISION_SUCCESS = 'PERSONALITY_REPORT_VISION_GET_SUCCESS',
}

export const personalityReportActions = {
  getPersonalityReport: (payload: { accountId: string }) =>
    createAction(EPersonalityReportActions.GET, payload),
  getPersonalityReportSuccess: (payload: {
    values: IPersonalityReport;
    vision: IPersonalityReport;
    personality: IPersonalityReport;
  }) => createAction(EPersonalityReportActions.GET_SUCCESS, payload),
  getPersonalityReportVision: (payload: { accountId: string }) =>
    createAction(EPersonalityReportActions.GET_VISION, payload),
  getPersonalityReportVisionSuccess: (payload: {
    vision: IPersonalityReport;
  }) => createAction(EPersonalityReportActions.GET_VISION_SUCCESS, payload),
};

export type IPersonalityReportAction = ActionsUnion<
  typeof personalityReportActions
>;
